import { useState } from "react";
import styled from "styled-components/macro";
import { BOX_SHADOW_TOOLTIP } from "constants/constants";
import { useSpring, animated } from "@react-spring/web";
import { useEventListener } from "utils/customHooks/genericHooks";
import { useSettings } from "contexts/SettingsManager/SettingsManager";

const TooltipStyles = styled.div`
  background: white;
  box-shadow: ${BOX_SHADOW_TOOLTIP};
  border: 1px solid tomato;
  border-radius: 4px;
  padding: 0.5em;
  opacity: 0.9;
`;

/** Little tooltip that follows your mouse and displays the name of the component under your cursor */
function ComponentNamesTooltip() {
  const { showComponentNames } = useSettings();

  return showComponentNames ? <ComponentNamesTooltipContents /> : null;
}

export default ComponentNamesTooltip;
const ComponentNamesTooltipContents = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [componentName, setComponentName] = useState("--");

  function handleMouseMove(event: MouseEvent) {
    // follow the mouse
    setPosition({ x: Math.min(event.x, window.innerWidth - 200), y: event.y });

    // climb the event.path (node tree) until we find a node with a data-component-name
    let found = false;
    (event as any)?.path?.forEach(node => {
      if (!found && node.dataset?.componentName) {
        setComponentName(node.dataset?.componentName);
        // stop at the first (lowest-in-the-tree) that we find
        found = true;
      }
    });

    if (!found) {
      setComponentName("--");
    }
  }

  useEventListener("mousemove", handleMouseMove);

  const springToMousePosition = useSpring({
    zIndex: 99999, // must be above material-ui floating component
    top: position.y + 22,
    left: position.x + 12,
    config: { tension: 1000, mass: 0.1 },
  });

  return (
    <animated.div style={{ position: "fixed", ...springToMousePosition }}>
      <TooltipStyles>{componentName}</TooltipStyles>
    </animated.div>
  );
};
